__turbopack_context__.v({
  "Background": "KBjHKa_Background",
  "Card": "KBjHKa_Card",
  "ClipContainer": "KBjHKa_ClipContainer",
  "Container": "KBjHKa_Container",
  "Content": "KBjHKa_Content",
  "Highlight": "KBjHKa_Highlight",
  "Image": "KBjHKa_Image",
  "ImageContainer": "KBjHKa_ImageContainer",
  "ImageTextCard": "KBjHKa_ImageTextCard",
  "ImageTextCardContainer": "KBjHKa_ImageTextCardContainer",
  "ImageTextCardText": "KBjHKa_ImageTextCardText",
  "ImageTextCardTextWrapper": "KBjHKa_ImageTextCardTextWrapper",
  "ImageTextCardTitle": "KBjHKa_ImageTextCardTitle",
  "Inner": "KBjHKa_Inner",
  "Root": "KBjHKa_Root",
  "Stuck": "KBjHKa_Stuck",
  "Text": "KBjHKa_Text",
  "TextContainer": "KBjHKa_TextContainer",
  "Title": "KBjHKa_Title",
  "skeleton-loading": "KBjHKa_skeleton-loading",
});
